// Strings for S6-stop. Only the S6-stop worker edits this file (see web/README.md).
// Copy from prototype/index.html (#S6-stop).
export default {
  title: 'The airline was within its rights',
  sub: "Without the right documents for the flight, being refused boarding isn't compensable — so this one won't qualify, now or later. We'd rather say so than take your details.",
  newCheck: 'Check a different flight',
} as const;
